import PubSubJs from 'pubsub-js';
import _ from 'lodash';
import { IS_TEST_ENV } from '../constants';
import marketMiddleware from './middleware/market';

const APP_UTILS_CHANGE_EVENT = Symbol('APP_UTILS_CHANGE_EVENT');
let appUtils;
const middlewares = [marketMiddleware];
const _AppUtils = {
    set: (utils) => {
        appUtils = Object.freeze(middlewares.reduce((acc, middleware) => middleware(acc), utils));
        PubSubJs.publish(APP_UTILS_CHANGE_EVENT, appUtils);
    },
    get: () => {
        return appUtils;
    },
    subscribe: (cb) => {
        if (appUtils) {
            _.defer(cb, appUtils);
        }
        return PubSubJs.subscribe(APP_UTILS_CHANGE_EVENT, (event, utils) => cb(utils));
    },
    unsubscribe: (token: string) => {
        return PubSubJs.unsubscribe(token);
    },
};
const AppUtils = IS_TEST_ENV ? _AppUtils : Object.freeze(_AppUtils);
export default AppUtils;
